import { render } from "./ByMoat.vue?vue&type=template&id=77d0c4e8"
import script from "./ByMoat.vue?vue&type=script&lang=js"
export * from "./ByMoat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__